window.UTIL =

  #----------------------------

  keys: (obj) ->
    return [] if typeof obj isnt "object"

    keys = []
    for k of obj
      keys.push k

    keys


  #----------------------------

  contains: (a, obj) ->
    return if not a?.length? or not obj?

    i = 0
    while i < a.length
      if a[i] == obj
        return true
      i++
    false

  #----------------------------

  debounce: (func, wait, immediate) ->
    timeout = undefined
    ->
      context = this
      args = arguments

      later = ->
        timeout = null
        if !immediate
          func.apply context, args
        return

      callNow = immediate and !timeout
      clearTimeout timeout
      timeout = setTimeout(later, wait)
      if callNow
        func.apply context, args
      return

  #----------------------------

  clone: (obj) ->
    JSON.parse(JSON.stringify(obj))

  #----------------------------

  getQueryParam: (variable, query) ->
    unless query?
      query = window.location.search.substring(1)

    variables = []

    if typeof variable is 'string'
      variables = [variable.toLowerCase()]
    else
      for v in variable
        variables.push v.toLowerCase()

    vars = query.split('&')
    i = 0
    while i < vars.length
      pair = vars[i].split('=')
      if pair[0].toLowerCase() in variables
        return @parseValues pair[1]
      i++
    null

  #----------------------------

  getQueryAsObj: (query) ->
    unless query?
      query = window.location.search.substring(1)

    tmp = {}
    vars = query.split('&')
    i = 0
    while i < vars.length
      pair = vars[i].split('=')
      tmp[pair[0]] = pair[1]
      i++
    tmp

  #----------------------------

  parseValues: (v) ->
    return v if typeof v isnt 'string'
    return null if v is ''
    return true if v is 'true'
    return false if v is 'false'
    return Number v if not isNaN Number v
    return null if v is 'null'
    return v

  #----------------------------

  hexToString: (int) ->
    k = (int + Math.pow(16, 6)).toString(16).substr(-6)
    return "#" + k.toString(16)


// WEBPACK FOOTER //
// ./coffee/app/util.coffee